module.exports = __webpack_public_path__ + "img/kh.572fd895.svg";